"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AddOn = _interopRequireDefault(require("../model/AddOn"));
var _AssignSim = _interopRequireDefault(require("../model/AssignSim"));
var _BalanceTransfer = _interopRequireDefault(require("../model/BalanceTransfer"));
var _BalanceTransform = _interopRequireDefault(require("../model/BalanceTransform"));
var _BooleanValueAddedService = _interopRequireDefault(require("../model/BooleanValueAddedService"));
var _Catalog = _interopRequireDefault(require("../model/Catalog"));
var _ContentPage = _interopRequireDefault(require("../model/ContentPage"));
var _DisconnectService = _interopRequireDefault(require("../model/DisconnectService"));
var _Discount = _interopRequireDefault(require("../model/Discount"));
var _DispatchSim = _interopRequireDefault(require("../model/DispatchSim"));
var _EShop = _interopRequireDefault(require("../model/EShop"));
var _ETicket = _interopRequireDefault(require("../model/ETicket"));
var _LinkAccount = _interopRequireDefault(require("../model/LinkAccount"));
var _MediaPayPerView = _interopRequireDefault(require("../model/MediaPayPerView"));
var _MediaSubscription = _interopRequireDefault(require("../model/MediaSubscription"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _ModifyAccountDetails = _interopRequireDefault(require("../model/ModifyAccountDetails"));
var _ModifyServiceDetails = _interopRequireDefault(require("../model/ModifyServiceDetails"));
var _ModifyUserDetails = _interopRequireDefault(require("../model/ModifyUserDetails"));
var _ParameterizedValueAddedService = _interopRequireDefault(require("../model/ParameterizedValueAddedService"));
var _PayInvoice = _interopRequireDefault(require("../model/PayInvoice"));
var _Plan = _interopRequireDefault(require("../model/Plan"));
var _PortIn = _interopRequireDefault(require("../model/PortIn"));
var _Product = _interopRequireDefault(require("../model/Product"));
var _Recharge = _interopRequireDefault(require("../model/Recharge"));
var _RegisterUser = _interopRequireDefault(require("../model/RegisterUser"));
var _SignUpCustomer = _interopRequireDefault(require("../model/SignUpCustomer"));
var _SignUpPostPaidCustomer = _interopRequireDefault(require("../model/SignUpPostPaidCustomer"));
var _SignUpPrePaidCustomer = _interopRequireDefault(require("../model/SignUpPrePaidCustomer"));
var _TechnicalOffer = _interopRequireDefault(require("../model/TechnicalOffer"));
var _TokenizeCard = _interopRequireDefault(require("../model/TokenizeCard"));
var _UnLinkAccount = _interopRequireDefault(require("../model/UnLinkAccount"));
var _UnLockCustomer = _interopRequireDefault(require("../model/UnLockCustomer"));
var _UnRegisterUser = _interopRequireDefault(require("../model/UnRegisterUser"));
var _UpdateCustomerAddress = _interopRequireDefault(require("../model/UpdateCustomerAddress"));
var _UpdateCustomerEmail = _interopRequireDefault(require("../model/UpdateCustomerEmail"));
var _UpdatePersonalDetails = _interopRequireDefault(require("../model/UpdatePersonalDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Catalog service.
* @module api/CatalogApi
* @version 3.0
*/
var CatalogApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new CatalogApi. 
  * @alias module:api/CatalogApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function CatalogApi(apiClient) {
    _classCallCheck(this, CatalogApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * List Add Ons
   * Get a list of AddOns from the Catalog.<br>Passing in an accountId will return Add Ons that can be added to that Account determined by Product rules.<br>Passing in an accountId AND serviceId will return Add Ons that can be added to that Account and Service based on the current Product Instances and Product rules.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
   * @param {Number} catalogId Catalog Id
   * @param {Object} opts Optional parameters
   * @param {Number} [accountId = 0)] Account Id
   * @param {Number} [serviceId = 0)] Service Id
   * @param {String} [tags] Tags
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AddOn>} and HTTP response
   */
  return _createClass(CatalogApi, [{
    key: "getAddOnsProductsWithHttpInfo",
    value: function getAddOnsProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getAddOnsProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'accountId': opts['accountId'],
        'serviceId': opts['serviceId'],
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_AddOn["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-addons', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Add Ons
     * Get a list of AddOns from the Catalog.<br>Passing in an accountId will return Add Ons that can be added to that Account determined by Product rules.<br>Passing in an accountId AND serviceId will return Add Ons that can be added to that Account and Service based on the current Product Instances and Product rules.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
     * @param {Number} catalogId Catalog Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId Account Id (default to 0)
     * @param {Number} opts.serviceId Service Id (default to 0)
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AddOn>}
     */
  }, {
    key: "getAddOnsProducts",
    value: function getAddOnsProducts(catalogId, opts) {
      return this.getAddOnsProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List assign SIM Products
     * Get a list of assign SIM products from the catalog.<br>Used to assign a given SIM number (ICCID) to a serviceTags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AssignSim>} and HTTP response
     */
  }, {
    key: "getAssignSimProductsWithHttpInfo",
    value: function getAssignSimProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getAssignSimProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_AssignSim["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-assignsim', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List assign SIM Products
     * Get a list of assign SIM products from the catalog.<br>Used to assign a given SIM number (ICCID) to a serviceTags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AssignSim>}
     */
  }, {
    key: "getAssignSimProducts",
    value: function getAssignSimProducts(catalogId, opts) {
      return this.getAssignSimProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Balance Transfer Products
     * Get a list of all Balance Transfer Products from the Catalog.<br>Balance Transfer Products are used to gift some of an applicable Balance to another Service (only when the required configuration is done).<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BalanceTransfer>} and HTTP response
     */
  }, {
    key: "getBalanceTransferProductsWithHttpInfo",
    value: function getBalanceTransferProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getBalanceTransferProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BalanceTransfer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-balancetransfer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Balance Transfer Products
     * Get a list of all Balance Transfer Products from the Catalog.<br>Balance Transfer Products are used to gift some of an applicable Balance to another Service (only when the required configuration is done).<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BalanceTransfer>}
     */
  }, {
    key: "getBalanceTransferProducts",
    value: function getBalanceTransferProducts(catalogId, opts) {
      return this.getBalanceTransferProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Balance Transform Products
     * Get a list of all Balance Transform Products from the Catalog.<br>Balance Transform Products are used to transform one type of Balance into another (e.g. data to minutes). (only when the required configuration is done)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BalanceTransform>} and HTTP response
     */
  }, {
    key: "getBalanceTransformProductsWithHttpInfo",
    value: function getBalanceTransformProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getBalanceTransformProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BalanceTransform["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-balancetransform', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Balance Transform Products
     * Get a list of all Balance Transform Products from the Catalog.<br>Balance Transform Products are used to transform one type of Balance into another (e.g. data to minutes). (only when the required configuration is done)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BalanceTransform>}
     */
  }, {
    key: "getBalanceTransformProducts",
    value: function getBalanceTransformProducts(catalogId, opts) {
      return this.getBalanceTransformProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Boolean Value Added Services Products
     * Get the Boolean Value Added Service Products from the Catalog.<br>Boolean Value Added Service Products control a number of extra features on a service which can be represented as a Boolean, such as Voicemail on/off.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BooleanValueAddedService>} and HTTP response
     */
  }, {
    key: "getBooleanValueAddedServicesProductsWithHttpInfo",
    value: function getBooleanValueAddedServicesProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getBooleanValueAddedServicesProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BooleanValueAddedService["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-booleanvalueaddedservices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Boolean Value Added Services Products
     * Get the Boolean Value Added Service Products from the Catalog.<br>Boolean Value Added Service Products control a number of extra features on a service which can be represented as a Boolean, such as Voicemail on/off.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BooleanValueAddedService>}
     */
  }, {
    key: "getBooleanValueAddedServicesProducts",
    value: function getBooleanValueAddedServicesProducts(catalogId, opts) {
      return this.getBooleanValueAddedServicesProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a list of all Bundles from the Catalog.<br>Bundles are a type of product which contains multiple products or allowances.<br>
     * Get a list of Bundles from the catalog.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Product>} and HTTP response
     */
  }, {
    key: "getBundleProductsWithHttpInfo",
    value: function getBundleProductsWithHttpInfo(catalogId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getBundleProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Product["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-bundles', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a list of all Bundles from the Catalog.<br>Bundles are a type of product which contains multiple products or allowances.<br>
     * Get a list of Bundles from the catalog.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Product>}
     */
  }, {
    key: "getBundleProducts",
    value: function getBundleProducts(catalogId) {
      return this.getBundleProductsWithHttpInfo(catalogId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List the available catalogs
     * Get a list of Catalogs in the system. Catalogs that are active are marked as such. Using the ‘operator code’ filter will limit the Catalogs returned to only the given operator 
     * @param {Object} opts Optional parameters
     * @param {String} [operatorCode] Operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Catalog>} and HTTP response
     */
  }, {
    key: "getCatalogsWithHttpInfo",
    value: function getCatalogsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'operatorCode': opts['operatorCode']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Catalog["default"]];
      return this.apiClient.callApi('/catalogs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List the available catalogs
     * Get a list of Catalogs in the system. Catalogs that are active are marked as such. Using the ‘operator code’ filter will limit the Catalogs returned to only the given operator 
     * @param {Object} opts Optional parameters
     * @param {String} opts.operatorCode Operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Catalog>}
     */
  }, {
    key: "getCatalogs",
    value: function getCatalogs(opts) {
      return this.getCatalogsWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Content Page Products
     * Get a list of Content Page products from the Catalog.<br>These are Products which are specifically linked to Content Pages.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ContentPage>} and HTTP response
     */
  }, {
    key: "getContentPageProductsWithHttpInfo",
    value: function getContentPageProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getContentPageProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ContentPage["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-contentpage', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Content Page Products
     * Get a list of Content Page products from the Catalog.<br>These are Products which are specifically linked to Content Pages.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ContentPage>}
     */
  }, {
    key: "getContentPageProducts",
    value: function getContentPageProducts(catalogId, opts) {
      return this.getContentPageProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Disconnect Service Products
     * Get a list of Disconnect Service Products from the Catalog.<br>These Products are used to Disconnect a Service for whatever reason.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DisconnectService>} and HTTP response
     */
  }, {
    key: "getDisconnectServiceProductsWithHttpInfo",
    value: function getDisconnectServiceProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getDisconnectServiceProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_DisconnectService["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-disconnectservice', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Disconnect Service Products
     * Get a list of Disconnect Service Products from the Catalog.<br>These Products are used to Disconnect a Service for whatever reason.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DisconnectService>}
     */
  }, {
    key: "getDisconnectServiceProducts",
    value: function getDisconnectServiceProducts(catalogId, opts) {
      return this.getDisconnectServiceProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Discount Products
     * Get all Discount Products from the Catalog.<br>Discounts are related to the Products in the Basket and can only be applied if the correct Products are present.<br>If a productId is passed in the list of Discounts returned will be filtered to only those that are available for the Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} [productId = 0)] Product Id
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Discount>} and HTTP response
     */
  }, {
    key: "getDiscountProductsWithHttpInfo",
    value: function getDiscountProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getDiscountProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'productId': opts['productId'],
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Discount["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-discounts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Discount Products
     * Get all Discount Products from the Catalog.<br>Discounts are related to the Products in the Basket and can only be applied if the correct Products are present.<br>If a productId is passed in the list of Discounts returned will be filtered to only those that are available for the Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} opts.productId Product Id (default to 0)
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Discount>}
     */
  }, {
    key: "getDiscountProducts",
    value: function getDiscountProducts(catalogId, opts) {
      return this.getDiscountProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Dispatch SIM Products
     * Get a list of Dispatch SIM Products from the Catalog.<br>Dispatch SIM Products are used to handling the dispatching of a physical SIM to a Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DispatchSim>} and HTTP response
     */
  }, {
    key: "getDispatchSimProductsWithHttpInfo",
    value: function getDispatchSimProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getDispatchSimProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_DispatchSim["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-dispatchsim', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Dispatch SIM Products
     * Get a list of Dispatch SIM Products from the Catalog.<br>Dispatch SIM Products are used to handling the dispatching of a physical SIM to a Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DispatchSim>}
     */
  }, {
    key: "getDispatchSimProducts",
    value: function getDispatchSimProducts(catalogId, opts) {
      return this.getDispatchSimProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List eShop Products
     * Get a list of eShop products from the catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/EShop>} and HTTP response
     */
  }, {
    key: "getEShopProductsWithHttpInfo",
    value: function getEShopProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getEShopProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_EShop["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-eshop', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List eShop Products
     * Get a list of eShop products from the catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/EShop>}
     */
  }, {
    key: "getEShopProducts",
    value: function getEShopProducts(catalogId, opts) {
      return this.getEShopProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List eTicket Products
     * Get a list of eTicket products from the Catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ETicket>} and HTTP response
     */
  }, {
    key: "getETicketProductsWithHttpInfo",
    value: function getETicketProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getETicketProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ETicket["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-eticket', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List eTicket Products
     * Get a list of eTicket products from the Catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which matchALL of the tags passed in <br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ETicket>}
     */
  }, {
    key: "getETicketProducts",
    value: function getETicketProducts(catalogId, opts) {
      return this.getETicketProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Link Account Products
     * Get a list of Link Account Products from the Catalog.<br>These products can link an account to a customer. For example, adding a broadband Account to an existing mobile Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/LinkAccount>} and HTTP response
     */
  }, {
    key: "getLinkAccountProductsWithHttpInfo",
    value: function getLinkAccountProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getLinkAccountProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_LinkAccount["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-linkaccount', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Link Account Products
     * Get a list of Link Account Products from the Catalog.<br>These products can link an account to a customer. For example, adding a broadband Account to an existing mobile Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/LinkAccount>}
     */
  }, {
    key: "getLinkAccountProducts",
    value: function getLinkAccountProducts(catalogId, opts) {
      return this.getLinkAccountProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Media Pay Per View Products.
     * Get a list of Media Pay Per View Products from the Catalog.<br>A tier can be added to narrow down the Media Pay Per Views returned to Products available to that specific tier.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @param {String} [tier] Tier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/MediaPayPerView>} and HTTP response
     */
  }, {
    key: "getMediaPayPerViewProductsWithHttpInfo",
    value: function getMediaPayPerViewProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getMediaPayPerViewProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags'],
        'tier': opts['tier']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_MediaPayPerView["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-mediapayperviews', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Media Pay Per View Products.
     * Get a list of Media Pay Per View Products from the Catalog.<br>A tier can be added to narrow down the Media Pay Per Views returned to Products available to that specific tier.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @param {String} opts.tier Tier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/MediaPayPerView>}
     */
  }, {
    key: "getMediaPayPerViewProducts",
    value: function getMediaPayPerViewProducts(catalogId, opts) {
      return this.getMediaPayPerViewProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Media Subscription Products.
     * Get a list of Media Subscription Products from the Catalog.<br>A tier can be added to narrow down the Media Subscriptions returned to Products available to that specific tier.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @param {String} [tier] Tier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/MediaSubscription>} and HTTP response
     */
  }, {
    key: "getMediaSubscriptionProductsWithHttpInfo",
    value: function getMediaSubscriptionProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getMediaSubscriptionProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags'],
        'tier': opts['tier']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_MediaSubscription["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-mediasubscriptions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Media Subscription Products.
     * Get a list of Media Subscription Products from the Catalog.<br>A tier can be added to narrow down the Media Subscriptions returned to Products available to that specific tier.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @param {String} opts.tier Tier
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/MediaSubscription>}
     */
  }, {
    key: "getMediaSubscriptionProducts",
    value: function getMediaSubscriptionProducts(catalogId, opts) {
      return this.getMediaSubscriptionProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Modify Account Details Products
     * Get a list of Modify Account Details Products from the Catalog.<br>These Products can be used to modify information on the Account, specified in the extended data on each Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ModifyAccountDetails>} and HTTP response
     */
  }, {
    key: "getModifyAccountDetailsProductsWithHttpInfo",
    value: function getModifyAccountDetailsProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getModifyAccountDetailsProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ModifyAccountDetails["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-modifyaccountdetails', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Modify Account Details Products
     * Get a list of Modify Account Details Products from the Catalog.<br>These Products can be used to modify information on the Account, specified in the extended data on each Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ModifyAccountDetails>}
     */
  }, {
    key: "getModifyAccountDetailsProducts",
    value: function getModifyAccountDetailsProducts(catalogId, opts) {
      return this.getModifyAccountDetailsProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Modify Service Details Products
     * Get a list of Modify Service Details Products from the Catalog.<br>These Products can be used to modify information specific to the Service, the details are specified in the extended data on each Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ModifyServiceDetails>} and HTTP response
     */
  }, {
    key: "getModifyServiceDetailsProductsWithHttpInfo",
    value: function getModifyServiceDetailsProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getModifyServiceDetailsProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ModifyServiceDetails["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-modifyservicedetails', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Modify Service Details Products
     * Get a list of Modify Service Details Products from the Catalog.<br>These Products can be used to modify information specific to the Service, the details are specified in the extended data on each Product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ModifyServiceDetails>}
     */
  }, {
    key: "getModifyServiceDetailsProducts",
    value: function getModifyServiceDetailsProducts(catalogId, opts) {
      return this.getModifyServiceDetailsProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Modify User Products
     * Get a list of Modify User Details Products from the Catalog.<br>These Products can be used to modify information specific to the User, the details are specified in the extended data on each product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ModifyUserDetails>} and HTTP response
     */
  }, {
    key: "getModifyUserDetailsProductsWithHttpInfo",
    value: function getModifyUserDetailsProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getModifyUserDetailsProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ModifyUserDetails["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-modifyuserdetails', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Modify User Products
     * Get a list of Modify User Details Products from the Catalog.<br>These Products can be used to modify information specific to the User, the details are specified in the extended data on each product.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ModifyUserDetails>}
     */
  }, {
    key: "getModifyUserDetailsProducts",
    value: function getModifyUserDetailsProducts(catalogId, opts) {
      return this.getModifyUserDetailsProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Parameterized Value Added Services Products
     * Get the Parametrized Value Added Service Products from the Catalog.<br>Parameterized Value Added Service products control a number of extra features on a Service including things like spending limits.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ParameterizedValueAddedService>} and HTTP response
     */
  }, {
    key: "getParameterizedValueAddedServicesProductsWithHttpInfo",
    value: function getParameterizedValueAddedServicesProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getParameterizedValueAddedServicesProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ParameterizedValueAddedService["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-parameterizedvalueaddedservices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Parameterized Value Added Services Products
     * Get the Parametrized Value Added Service Products from the Catalog.<br>Parameterized Value Added Service products control a number of extra features on a Service including things like spending limits.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ParameterizedValueAddedService>}
     */
  }, {
    key: "getParameterizedValueAddedServicesProducts",
    value: function getParameterizedValueAddedServicesProducts(catalogId, opts) {
      return this.getParameterizedValueAddedServicesProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Pay Invoices Products
     * Get a list of Pay Invoice Products from the Catalog.<br>Pay Invoice Products are used to make a Payment against an Invoice (postpaid bill).<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PayInvoice>} and HTTP response
     */
  }, {
    key: "getPayInvoicesProductsWithHttpInfo",
    value: function getPayInvoicesProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getPayInvoicesProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PayInvoice["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-payinvoices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Pay Invoices Products
     * Get a list of Pay Invoice Products from the Catalog.<br>Pay Invoice Products are used to make a Payment against an Invoice (postpaid bill).<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PayInvoice>}
     */
  }, {
    key: "getPayInvoicesProducts",
    value: function getPayInvoicesProducts(catalogId, opts) {
      return this.getPayInvoicesProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Plans.
     * Get a list of Plan Products from the Catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Plan>} and HTTP response
     */
  }, {
    key: "getPlansProductsWithHttpInfo",
    value: function getPlansProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getPlansProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Plan["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-plans', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Plans.
     * Get a list of Plan Products from the Catalog.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Plan>}
     */
  }, {
    key: "getPlansProducts",
    value: function getPlansProducts(catalogId, opts) {
      return this.getPlansProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Port In Products
     * Get a list of Port In Products from the Catalog.<br>Port In Products are used for portability scenarios.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PortIn>} and HTTP response
     */
  }, {
    key: "getPortInProductsWithHttpInfo",
    value: function getPortInProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getPortInProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PortIn["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-portin', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Port In Products
     * Get a list of Port In Products from the Catalog.<br>Port In Products are used for portability scenarios.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PortIn>}
     */
  }, {
    key: "getPortInProducts",
    value: function getPortInProducts(catalogId, opts) {
      return this.getPortInProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Product Details
     * Get a specific Product details which matches the given productId<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Product} and HTTP response
     */
  }, {
    key: "getProductWithHttpInfo",
    value: function getProductWithHttpInfo(catalogId, productId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProduct");
      }
      var pathParams = {
        'catalogId': catalogId,
        'productId': productId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Product["default"];
      return this.apiClient.callApi('/catalogs/{catalogId}/products/{productId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Product Details
     * Get a specific Product details which matches the given productId<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Product}
     */
  }, {
    key: "getProduct",
    value: function getProduct(catalogId, productId) {
      return this.getProductWithHttpInfo(catalogId, productId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Product’s Image from its display details
     * Gets a specific image from a Product’s display details.<br>The image returned is an SVG string which will need to be converted for it to be displayed.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @param {Number} displayDetailId Display Detail ID
     * @param {Number} imageid Image ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */
  }, {
    key: "getProductDisplayDetailsImageWithHttpInfo",
    value: function getProductDisplayDetailsImageWithHttpInfo(catalogId, productId, displayDetailId, imageid) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getProductDisplayDetailsImage");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductDisplayDetailsImage");
      }
      // verify the required parameter 'displayDetailId' is set
      if (displayDetailId === undefined || displayDetailId === null) {
        throw new Error("Missing the required parameter 'displayDetailId' when calling getProductDisplayDetailsImage");
      }
      // verify the required parameter 'imageid' is set
      if (imageid === undefined || imageid === null) {
        throw new Error("Missing the required parameter 'imageid' when calling getProductDisplayDetailsImage");
      }
      var pathParams = {
        'catalogId': catalogId,
        'productId': productId,
        'displayDetailId': displayDetailId,
        'imageid': imageid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = 'String';
      return this.apiClient.callApi('/catalogs/{catalogId}/products/{productId}/displaydetails/{displayDetailId}/image/{imageid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Product’s Image from its display details
     * Gets a specific image from a Product’s display details.<br>The image returned is an SVG string which will need to be converted for it to be displayed.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @param {Number} displayDetailId Display Detail ID
     * @param {Number} imageid Image ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */
  }, {
    key: "getProductDisplayDetailsImage",
    value: function getProductDisplayDetailsImage(catalogId, productId, displayDetailId, imageid) {
      return this.getProductDisplayDetailsImageWithHttpInfo(catalogId, productId, displayDetailId, imageid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a  Product option.
     * Gets a Product option including all the available values for the option
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @param {Number} optionId Option ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Product} and HTTP response
     */
  }, {
    key: "getProductOptionWithHttpInfo",
    value: function getProductOptionWithHttpInfo(catalogId, productId, optionId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getProductOption");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductOption");
      }
      // verify the required parameter 'optionId' is set
      if (optionId === undefined || optionId === null) {
        throw new Error("Missing the required parameter 'optionId' when calling getProductOption");
      }
      var pathParams = {
        'catalogId': catalogId,
        'productId': productId,
        'optionId': optionId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Product["default"];
      return this.apiClient.callApi('/catalogs/{catalogId}/products/{productId}/options/{optionId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a  Product option.
     * Gets a Product option including all the available values for the option
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Product ID
     * @param {Number} optionId Option ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Product}
     */
  }, {
    key: "getProductOption",
    value: function getProductOption(catalogId, productId, optionId) {
      return this.getProductOptionWithHttpInfo(catalogId, productId, optionId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all Catalog Products.
     * Get a list of Products from the Catalog.<br>Products can be added to a Basket at the customer, account or service level.<br>Passing in an accountId will return Products that can be added to that Account determined by Product Rules.<br>Passing in an accountId AND serviceId will return Products that can be added to that Account and/or Service based on the Product Rules.<br>Product Legacy Ids can be passed in as a comma separated list. Passing in Product legacy Ids will filter the results to those Products which match the legacy Ids.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If SaleStartDateTime is passed in, only the Products whose sale start date is after this date will be returned.<br>if AvailableFromDateTime is passed in, only the Products whose expiry date is after this date will be returned - the default is 'now'.<br>If includeExpired is passed in, expired Products (expiry date has passed) will be returned.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} [accountId = 0)] Account Id
     * @param {Number} [serviceId = 0)] Service Id
     * @param {String} [category] Category
     * @param {String} [productLegacyIds] Product Legacy Ids
     * @param {String} [tags] Tags
     * @param {String} [saleStartDateTime] SaleStartDateTime
     * @param {String} [availableFromDateTime] AvailableFromDateTime
     * @param {String} [includeExpired] includeExpired
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Product>} and HTTP response
     */
  }, {
    key: "getProductsWithHttpInfo",
    value: function getProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'accountId': opts['accountId'],
        'serviceId': opts['serviceId'],
        'category': opts['category'],
        'productLegacyIds': opts['productLegacyIds'],
        'tags': opts['tags'],
        'saleStartDateTime': opts['saleStartDateTime'],
        'availableFromDateTime': opts['availableFromDateTime'],
        'includeExpired': opts['includeExpired']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Product["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all Catalog Products.
     * Get a list of Products from the Catalog.<br>Products can be added to a Basket at the customer, account or service level.<br>Passing in an accountId will return Products that can be added to that Account determined by Product Rules.<br>Passing in an accountId AND serviceId will return Products that can be added to that Account and/or Service based on the Product Rules.<br>Product Legacy Ids can be passed in as a comma separated list. Passing in Product legacy Ids will filter the results to those Products which match the legacy Ids.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If SaleStartDateTime is passed in, only the Products whose sale start date is after this date will be returned.<br>if AvailableFromDateTime is passed in, only the Products whose expiry date is after this date will be returned - the default is 'now'.<br>If includeExpired is passed in, expired Products (expiry date has passed) will be returned.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId Account Id (default to 0)
     * @param {Number} opts.serviceId Service Id (default to 0)
     * @param {String} opts.category Category
     * @param {String} opts.productLegacyIds Product Legacy Ids
     * @param {String} opts.tags Tags
     * @param {String} opts.saleStartDateTime SaleStartDateTime
     * @param {String} opts.availableFromDateTime AvailableFromDateTime
     * @param {String} opts.includeExpired includeExpired
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Product>}
     */
  }, {
    key: "getProducts",
    value: function getProducts(catalogId, opts) {
      return this.getProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Recharge Products
     * Get a list of Recharge Products from the Catalog.<br>Recharge Products are used to increase a Prepaid monetary Balance.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Recharge>} and HTTP response
     */
  }, {
    key: "getRechargesProductsWithHttpInfo",
    value: function getRechargesProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getRechargesProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Recharge["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-recharges', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Recharge Products
     * Get a list of Recharge Products from the Catalog.<br>Recharge Products are used to increase a Prepaid monetary Balance.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Recharge>}
     */
  }, {
    key: "getRechargesProducts",
    value: function getRechargesProducts(catalogId, opts) {
      return this.getRechargesProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get RegisterUser Technical Offers
     * Get a list of Register User Technical Offers from the Catalog.<br>Register User Products are used to register a user, often as part of a Basket flow – for example, during a NCA.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/RegisterUser>} and HTTP response
     */
  }, {
    key: "getRegisterUserTechnicalOffersWithHttpInfo",
    value: function getRegisterUserTechnicalOffersWithHttpInfo(catalogId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getRegisterUserTechnicalOffers");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_RegisterUser["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-registeruser', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get RegisterUser Technical Offers
     * Get a list of Register User Technical Offers from the Catalog.<br>Register User Products are used to register a user, often as part of a Basket flow – for example, during a NCA.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/RegisterUser>}
     */
  }, {
    key: "getRegisterUserTechnicalOffers",
    value: function getRegisterUserTechnicalOffers(catalogId) {
      return this.getRegisterUserTechnicalOffersWithHttpInfo(catalogId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Sign Up Customer Technical Offers
     * Get a list of Sign Up Technical Offers from the Catalog.<br>The Sign Up Technical Offers are used to Sign Up a new customer in the back-end system specified in the Product.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SignUpCustomer>} and HTTP response
     */
  }, {
    key: "getSignUpCustomerTechnicalOffersWithHttpInfo",
    value: function getSignUpCustomerTechnicalOffersWithHttpInfo(catalogId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getSignUpCustomerTechnicalOffers");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_SignUpCustomer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-signupcustomer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Sign Up Customer Technical Offers
     * Get a list of Sign Up Technical Offers from the Catalog.<br>The Sign Up Technical Offers are used to Sign Up a new customer in the back-end system specified in the Product.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SignUpCustomer>}
     */
  }, {
    key: "getSignUpCustomerTechnicalOffers",
    value: function getSignUpCustomerTechnicalOffers(catalogId) {
      return this.getSignUpCustomerTechnicalOffersWithHttpInfo(catalogId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Signup PostPaid Customer Products
     * Get a list of Signup Postpaid Customer Products from the Catalog.<br>Postpaid Sign Up Products are used to sign up new Postpaid Customers (Also known as New Customer Acquisition)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SignUpPostPaidCustomer>} and HTTP response
     */
  }, {
    key: "getSignUpPostPaidCustomerProductsWithHttpInfo",
    value: function getSignUpPostPaidCustomerProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getSignUpPostPaidCustomerProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_SignUpPostPaidCustomer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-signuppostpaidcustomer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Signup PostPaid Customer Products
     * Get a list of Signup Postpaid Customer Products from the Catalog.<br>Postpaid Sign Up Products are used to sign up new Postpaid Customers (Also known as New Customer Acquisition)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SignUpPostPaidCustomer>}
     */
  }, {
    key: "getSignUpPostPaidCustomerProducts",
    value: function getSignUpPostPaidCustomerProducts(catalogId, opts) {
      return this.getSignUpPostPaidCustomerProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Signup PrePaid Customer Products
     * Get a list of Signup Prepaid Customer Products from the Catalog.<br>Prepaid Sign Up Products are used to sign up new Prepaid Customers (Also known as New Customer Acquisition)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SignUpPrePaidCustomer>} and HTTP response
     */
  }, {
    key: "getSignUpPrePaidCustomerProductsWithHttpInfo",
    value: function getSignUpPrePaidCustomerProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getSignUpPrePaidCustomerProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_SignUpPrePaidCustomer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-signupprepaidcustomer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Signup PrePaid Customer Products
     * Get a list of Signup Prepaid Customer Products from the Catalog.<br>Prepaid Sign Up Products are used to sign up new Prepaid Customers (Also known as New Customer Acquisition)<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SignUpPrePaidCustomer>}
     */
  }, {
    key: "getSignUpPrePaidCustomerProducts",
    value: function getSignUpPrePaidCustomerProducts(catalogId, opts) {
      return this.getSignUpPrePaidCustomerProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Technical Offer
     * Get a specific Technical Offer.<br>Technical Offers are special Products in the Catalog which are not available for purchase to Customers but are used to trigger workflows inside of the SR-SSB or back-end systems.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Technical Offer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TechnicalOffer} and HTTP response
     */
  }, {
    key: "getTechnicalOfferWithHttpInfo",
    value: function getTechnicalOfferWithHttpInfo(catalogId, productId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getTechnicalOffer");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getTechnicalOffer");
      }
      var pathParams = {
        'catalogId': catalogId,
        'productId': productId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _TechnicalOffer["default"];
      return this.apiClient.callApi('/catalogs/{catalogId}/technicaloffers/{productId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Technical Offer
     * Get a specific Technical Offer.<br>Technical Offers are special Products in the Catalog which are not available for purchase to Customers but are used to trigger workflows inside of the SR-SSB or back-end systems.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Number} productId Technical Offer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TechnicalOffer}
     */
  }, {
    key: "getTechnicalOffer",
    value: function getTechnicalOffer(catalogId, productId) {
      return this.getTechnicalOfferWithHttpInfo(catalogId, productId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Technical Offers.
     * Get a list of Technical Offers from the Catalog.<br>If an Account Id is provided then the returned list will only contain those Technical Offers that can be added to the Account without conflict.<br>If an Account Id and Service ID is provided then the returned list will only contain those Technical Offers that can be added to the Account AND the Service without conflict.<br>If a category is supplied then the Technical Offers will be filters accordingly.<br>Product Legacy Ids can be passed in as a comma separated list. Passing in Product legacy Ids will filter the results to those which match the legacy Ids .<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match all tags.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} [accountId = 0)] Account Id
     * @param {Number} [serviceId = 0)] Service Id
     * @param {String} [category] Category
     * @param {String} [productLegacyIds] Product Legacy Ids
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TechnicalOffer>} and HTTP response
     */
  }, {
    key: "getTechnicalOffersWithHttpInfo",
    value: function getTechnicalOffersWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getTechnicalOffers");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'accountId': opts['accountId'],
        'serviceId': opts['serviceId'],
        'category': opts['category'],
        'productLegacyIds': opts['productLegacyIds'],
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_TechnicalOffer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/technicaloffers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Technical Offers.
     * Get a list of Technical Offers from the Catalog.<br>If an Account Id is provided then the returned list will only contain those Technical Offers that can be added to the Account without conflict.<br>If an Account Id and Service ID is provided then the returned list will only contain those Technical Offers that can be added to the Account AND the Service without conflict.<br>If a category is supplied then the Technical Offers will be filters accordingly.<br>Product Legacy Ids can be passed in as a comma separated list. Passing in Product legacy Ids will filter the results to those which match the legacy Ids .<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match all tags.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId Account Id (default to 0)
     * @param {Number} opts.serviceId Service Id (default to 0)
     * @param {String} opts.category Category
     * @param {String} opts.productLegacyIds Product Legacy Ids
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TechnicalOffer>}
     */
  }, {
    key: "getTechnicalOffers",
    value: function getTechnicalOffers(catalogId, opts) {
      return this.getTechnicalOffersWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Tokenize Card Products
     * Get a list of Tokenize Card products from the Catalog.<br>These Products will tokenize a card as part of a transaction so that the token can be used for payments or can be saved against the Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TokenizeCard>} and HTTP response
     */
  }, {
    key: "getTokenizeCardProductsWithHttpInfo",
    value: function getTokenizeCardProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getTokenizeCardProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_TokenizeCard["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-tokenizecard', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Tokenize Card Products
     * Get a list of Tokenize Card products from the Catalog.<br>These Products will tokenize a card as part of a transaction so that the token can be used for payments or can be saved against the Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TokenizeCard>}
     */
  }, {
    key: "getTokenizeCardProducts",
    value: function getTokenizeCardProducts(catalogId, opts) {
      return this.getTokenizeCardProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List UnLinkAccount Products
     * Get a list of Unlink Account Products from the Catalog.<br>Unlink Account products are used to remove a link between an Account and a Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UnLinkAccount>} and HTTP response
     */
  }, {
    key: "getUnLinkAccountProductsWithHttpInfo",
    value: function getUnLinkAccountProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUnLinkAccountProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UnLinkAccount["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-unlinkaccount', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List UnLinkAccount Products
     * Get a list of Unlink Account Products from the Catalog.<br>Unlink Account products are used to remove a link between an Account and a Customer.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UnLinkAccount>}
     */
  }, {
    key: "getUnLinkAccountProducts",
    value: function getUnLinkAccountProducts(catalogId, opts) {
      return this.getUnLinkAccountProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Unlock Customer Product
     * Get a list of Unlock Customer Products from the Catalog.<br>The Unlock Customer Product can be used to remove a lock which has put onto a Customer for security reasons.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UnLockCustomer>} and HTTP response
     */
  }, {
    key: "getUnLockCustomerProductsWithHttpInfo",
    value: function getUnLockCustomerProductsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUnLockCustomerProducts");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UnLockCustomer["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-unlockcustomer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Unlock Customer Product
     * Get a list of Unlock Customer Products from the Catalog.<br>The Unlock Customer Product can be used to remove a lock which has put onto a Customer for security reasons.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UnLockCustomer>}
     */
  }, {
    key: "getUnLockCustomerProducts",
    value: function getUnLockCustomerProducts(catalogId, opts) {
      return this.getUnLockCustomerProductsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Unregister User Technical Offers
     * Get a list of Unregister User Products from the Catalog.<br>The Unregister User product can be used to remove a User from the SR-SSB.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UnRegisterUser>} and HTTP response
     */
  }, {
    key: "getUnRegisterUserTechnicalOffersWithHttpInfo",
    value: function getUnRegisterUserTechnicalOffersWithHttpInfo(catalogId) {
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUnRegisterUserTechnicalOffers");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UnRegisterUser["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-unregisteruser', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Unregister User Technical Offers
     * Get a list of Unregister User Products from the Catalog.<br>The Unregister User product can be used to remove a User from the SR-SSB.<br>
     * @param {Number} catalogId Catalog ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UnRegisterUser>}
     */
  }, {
    key: "getUnRegisterUserTechnicalOffers",
    value: function getUnRegisterUserTechnicalOffers(catalogId) {
      return this.getUnRegisterUserTechnicalOffersWithHttpInfo(catalogId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Update Customer Address Products
     * Get a list of Update Customer Address Products from the Catalog.<br>The Update Customer Address Product can be used to update the Customer’s Address in the SR-SSB and back end system.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UpdateCustomerAddress>} and HTTP response
     */
  }, {
    key: "getUpdateCustomerAddressWithHttpInfo",
    value: function getUpdateCustomerAddressWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUpdateCustomerAddress");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UpdateCustomerAddress["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-updatecustomeraddress', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Update Customer Address Products
     * Get a list of Update Customer Address Products from the Catalog.<br>The Update Customer Address Product can be used to update the Customer’s Address in the SR-SSB and back end system.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UpdateCustomerAddress>}
     */
  }, {
    key: "getUpdateCustomerAddress",
    value: function getUpdateCustomerAddress(catalogId, opts) {
      return this.getUpdateCustomerAddressWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Update Customer Email Products
     * Get a list of Update Customer Email Products from the Catalog.<br>The Update Customer Email Product will update the Customer’s email address inside of the SR-SSB and in any appropriate back end systems.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UpdateCustomerEmail>} and HTTP response
     */
  }, {
    key: "getUpdateCustomerEmailWithHttpInfo",
    value: function getUpdateCustomerEmailWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUpdateCustomerEmail");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UpdateCustomerEmail["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-updatecustomeremail', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Update Customer Email Products
     * Get a list of Update Customer Email Products from the Catalog.<br>The Update Customer Email Product will update the Customer’s email address inside of the SR-SSB and in any appropriate back end systems.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UpdateCustomerEmail>}
     */
  }, {
    key: "getUpdateCustomerEmail",
    value: function getUpdateCustomerEmail(catalogId, opts) {
      return this.getUpdateCustomerEmailWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Update Personal Details Products
     * Get a list of Update Personal Details Products from the Catalog.<br>These products can be used to change specific personal details in both the SR-SSB and any appropriate back end system.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} [tags] Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UpdatePersonalDetails>} and HTTP response
     */
  }, {
    key: "getUpdatePersonalDetailsWithHttpInfo",
    value: function getUpdatePersonalDetailsWithHttpInfo(catalogId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'catalogId' is set
      if (catalogId === undefined || catalogId === null) {
        throw new Error("Missing the required parameter 'catalogId' when calling getUpdatePersonalDetails");
      }
      var pathParams = {
        'catalogId': catalogId
      };
      var queryParams = {
        'tags': opts['tags']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_UpdatePersonalDetails["default"]];
      return this.apiClient.callApi('/catalogs/{catalogId}/products-updatepersonaldetails', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Update Personal Details Products
     * Get a list of Update Personal Details Products from the Catalog.<br>These products can be used to change specific personal details in both the SR-SSB and any appropriate back end system.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>
     * @param {Number} catalogId Catalog ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.tags Tags
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UpdatePersonalDetails>}
     */
  }, {
    key: "getUpdatePersonalDetails",
    value: function getUpdatePersonalDetails(catalogId, opts) {
      return this.getUpdatePersonalDetailsWithHttpInfo(catalogId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();